import type { StatusTone } from '@buildbee/ui';

/**
 * Lifecycle status -> Field Ledger status tone (shape + colour of the hexagon marker).
 * done: finished well; progress: moving; risk: needs attention; blocked: stopped or failed;
 * idle: not started yet, or set aside.
 */
const TONES: Record<string, StatusTone> = {
  // done
  completed: 'done',
  closed: 'done',
  approved: 'done',
  approved_as_noted: 'done',
  paid: 'done',
  won: 'done',
  answered: 'done',
  done: 'done',
  signed: 'done',
  accepted: 'done',
  executed: 'done',
  converted: 'done',
  awarded: 'done',
  received: 'done',
  installed: 'done',
  minutes_published: 'done',
  on_track: 'done',
  ok: 'done',
  succeeded: 'done',
  selected: 'done',
  applied: 'done',
  // progress
  active: 'progress',
  open: 'progress',
  in_progress: 'progress',
  submitted: 'progress',
  sent: 'progress',
  viewed: 'progress',
  pending: 'progress',
  pending_internal: 'progress',
  pending_client: 'progress',
  in_review: 'progress',
  ready_for_review: 'progress',
  requested: 'progress',
  partially_paid: 'progress',
  punch: 'progress',
  leveling: 'progress',
  scheduled: 'progress',
  minutes_draft: 'progress',
  invited: 'progress',
  ordered: 'progress',
  processing: 'progress',
  trialing: 'progress',
  // risk
  overdue: 'risk',
  past_due: 'risk',
  at_risk: 'risk',
  behind: 'risk',
  revise_resubmit: 'risk',
  expiring: 'risk',
  expired: 'risk',
  on_hold: 'risk',
  // blocked
  rejected: 'blocked',
  blocked: 'blocked',
  lost: 'blocked',
  void: 'blocked',
  cancelled: 'blocked',
  declined: 'blocked',
  failed: 'blocked',
  error: 'blocked',
  revoked: 'blocked',
  suspended: 'blocked',
  dead: 'blocked',
  conflict: 'blocked',
  // idle
  draft: 'idle',
  todo: 'idle',
  not_started: 'idle',
  planning: 'idle',
  planned: 'idle',
  preconstruction: 'idle',
  archived: 'idle',
  missing: 'idle',
  superseded: 'idle',
  withdrawn: 'idle',
  not_awarded: 'idle',
  disabled: 'idle',
  inactive: 'idle',
  discarded: 'idle',
};

export function statusTone(status: string): StatusTone {
  return TONES[status] ?? 'idle';
}
